import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';


const SocialFeed = () => {
  const socialPosts = [
  {
    platform: "Instagram",
    username: "@montesantobakery",
    image: "https://images.unsplash.com/photo-1569991808535-4c2b63dd377c",
    imageAlt: "Freshly baked golden croissants arranged on rustic wooden board with steam rising, morning sunlight streaming through bakery window",
    caption: "Fresh cornetti just out of the oven! ☀️ Come grab yours while they're warm",
    likes: 342,
    comments: 28,
    timeAgo: "2 hours ago"
  },
  {
    platform: "Instagram",
    username: "@montesantobakery",
    image: "https://images.unsplash.com/photo-1706188458145-f11cb33aa1a0",
    imageAlt: "Elegant three-tier white wedding cake decorated with fresh roses, delicate piping, and gold accents on marble display stand",
    caption: "Custom wedding cake for this weekend\'s celebration 💍✨",
    likes: 567,
    comments: 45,
    timeAgo: "1 day ago"
  },
  {
    platform: "Instagram",
    username: "@montesantobakery",
    image: "https://images.unsplash.com/photo-1732361551253-52d03322869b",
    imageAlt: "Artisan sourdough bread loaves with golden crispy crusts and flour dusting, displayed in woven basket with rustic cloth",
    caption: "Our signature sourdough - 48 hours of love and patience 🍞",
    likes: 289,
    comments: 19,
    timeAgo: "2 days ago"
  },
  {
    platform: "Instagram",
    username: "@montesantobakery",
    image: "https://images.unsplash.com/photo-1701351348533-ceeee1446329",
    imageAlt: "Colorful Italian gelato display with multiple flavors in metal containers, including pistachio, strawberry, chocolate, and vanilla",
    caption: "Gelato weather is here! 🍦 Try our authentic Italian flavors",
    likes: 421,
    comments: 34,
    timeAgo: "3 days ago"
  }];


  const socialLinks = [
  { platform: "Instagram", icon: "Instagram", url: "https://instagram.com", followers: "12.5K" },
  { platform: "Facebook", icon: "Facebook", url: "https://facebook.com", followers: "8.2K" },
  { platform: "Twitter", icon: "Twitter", url: "https://twitter.com", followers: "5.1K" }];


  return (
    <div className="bg-card rounded-2xl overflow-hidden shadow-warm">
      <div className="p-6 border-b border-border">
        <div className="flex items-center justify-between mb-2">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
              <Icon name="Instagram" size={20} color="var(--color-primary)" />
            </div>
            <h2 className="text-2xl font-serif font-semibold text-foreground">
              Follow Our Journey
            </h2>
          </div>
        </div>
        <p className="text-muted-foreground">
          Daily updates, behind-the-scenes, and customer celebrations
        </p>
      </div>
      <div className="p-6">
        <div className="flex gap-3 mb-6">
          {socialLinks?.map((social, index) =>
          <a
            key={index}
            href={social?.url}
            target="_blank"
            rel="noopener noreferrer"
            className="flex-1 p-4 rounded-xl bg-muted/30 hover:bg-primary/5 border border-border hover:border-primary/20 transition-all text-center group">

              <div className="w-10 h-10 rounded-lg bg-primary/10 group-hover:bg-primary/20 flex items-center justify-center mx-auto mb-2 transition-colors">
                <Icon name={social?.icon} size={20} color="var(--color-primary)" />
              </div>
              <p className="text-sm font-medium text-foreground mb-1">
                {social?.platform}
              </p>
              <p className="text-xs text-muted-foreground">
                {social?.followers} followers
              </p>
            </a>
          )}
        </div>

        <div className="grid grid-cols-2 gap-4">
          {socialPosts?.map((post, index) =>
          <div
            key={index}
            className="group rounded-xl overflow-hidden bg-muted/30 border border-border hover:border-primary/20 transition-all">

              <div className="relative h-48 overflow-hidden">
                <Image
                src={post?.image}
                alt={post?.imageAlt}
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />

                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity">
                  <div className="absolute bottom-3 left-3 right-3">
                    <div className="flex items-center gap-4 text-white text-sm">
                      <div className="flex items-center gap-1">
                        <Icon name="Heart" size={16} />
                        <span>{post?.likes}</span>
                      </div>
                      <div className="flex items-center gap-1">
                        <Icon name="MessageCircle" size={16} />
                        <span>{post?.comments}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="p-3">
                <p className="text-sm text-foreground line-clamp-2 mb-2">
                  {post?.caption}
                </p>
                <p className="text-xs text-muted-foreground">
                  {post?.timeAgo}
                </p>
              </div>
            </div>
          )}
        </div>

        <div className="mt-6">
          <a
            href="https://instagram.com/montesantobakery"
            target="_blank"
            rel="noopener noreferrer"
            className="block w-full">

            <Button
              variant="outline"
              fullWidth
              iconName="ExternalLink"
              iconPosition="right">

              View All Posts on Instagram
            </Button>
          </a>
        </div>

        <div className="mt-6 p-4 bg-gradient-to-br from-primary/5 to-accent/5 rounded-xl border border-primary/10">
          <div className="flex items-start gap-3">
            <Icon name="Camera" size={20} color="var(--color-primary)" className="mt-0.5 flex-shrink-0" />
            <div>
              <p className="text-sm font-medium text-foreground mb-1">
                Share Your Experience
              </p>
              <p className="text-sm text-muted-foreground">
                Tag us @montesantobakery in your photos and use #MontesantoMoments to be featured on our page!
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>);

};

export default SocialFeed;